import { YACHT_TYPE } from "../constants/actionTypes";

// locations reducer
export default function yachtType(state = [], action) {
  switch (action.type) {
    case YACHT_TYPE:
      return action.yachtType || [];

    // initial state
    default:
      return state;
  }
}
